import {Component} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router, RouterLink} from '@angular/router';
import {CommonModule} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from '@shared/services/security/auth.service';
import {SpinnerComponent} from '@shared/components/spinner/spinner.component';
import {DeviceInfoService} from "@shared/services/device-info/device-info.service";

@Component({
    selector: 'app-step-two',
    imports: [CommonModule, RouterLink, ReactiveFormsModule, SpinnerComponent],
    providers: [],
    templateUrl: './step-two.component.html',
    styleUrl: './step-two.component.scss'
})
export class StepTwoComponent {
    signinForm!: FormGroup;
    errorMessage!: string;
    loading = false;

    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private router: Router,
        public toastr: ToastrService,
        private deviceInfoService: DeviceInfoService
    ) {
    }

    ngOnInit(): void {
        if (this.authService.isUserLogged) {
            this.router.navigate(['']);
            return
        }
        if (!this.authService.isUserPrelogged) {
            this.router.navigate(['signin']);
            return

        }
        this.signinForm = this.fb.group({
            otp: ['', [Validators.required]]
        });
    }

    onSubmit() {
        if (this.signinForm.valid) {
            this.loading = true
            const otp = this.signinForm.value.otp;
            const deviceInfo = this.deviceInfoService.getDeviceInfo();
            const pretoken = this.authService.getPretoken()
            this.authService.stepTwo(pretoken, otp, deviceInfo).subscribe({
                next: (res: boolean) => {
                    if (res) {
                        this.router.navigate(['']);
                        this.toastr.success('Sign In Successful', ' ');
                    }
                    this.loading = false
                },
                error: (error) => {
                    this.loading = false
                    this.errorMessage = error.error.error;
                    this.toastr.error(this.errorMessage); // Assuming API returns error message
                    console.error('Sign in error:', error);
                }
            });
        } else {
            // Mark fields as touched to trigger validation messages
            this.signinForm.markAllAsTouched();
        }
    }
}
